import { heroQuickTags } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden pt-16">
      <div className="mx-auto flex w-full flex-col items-start px-4 pb-14 pt-12 md:px-6 md:pb-20 md:pt-16 lg:flex-row lg:items-center lg:justify-between">
        <div className="w-full lg:max-w-2xl">
          <p className="inline-flex items-center gap-2 rounded-full border border-accent-200 bg-accent-100/70 px-3 py-1 text-xs font-medium text-accent-800">
            <i className="ri-flashlight-line text-sm"></i>
            往期热门 · 完整版一页收齐
          </p>
          <h1 className="mt-5 font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 sm:text-4xl md:text-5xl">
            九色吃瓜打包合集、
            <span className="text-primary-600">大礼包</span>汇总入口
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
            打包合集、汇总帖、大礼包在这里整理完毕，往期热门完整版一键收藏，一个页面收齐全收录内容，省去到处翻找。支持打包下载方向指路，要打包看这一篇就够。
          </p>

          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#packs"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-stack-fill text-base"></i>
              进打包合集总览
            </a>
            <a
              href="#guide"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-compass-3-line text-base"></i>
              下载方向指路
            </a>
          </div>

          <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-foreground-600">
            {heroQuickTags.map((t) => (
              <span key={t} className="inline-flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-checkbox-circle-line text-accent-500"></i>
                {t}
              </span>
            ))}
          </div>
        </div>

        <div className="mt-10 w-full lg:mt-0 lg:w-auto lg:shrink-0">
          <div className="relative overflow-hidden rounded-2xl border border-background-200 bg-background-100 p-6 md:p-8">
            <span className="pointer-events-none absolute -right-8 -top-8 h-28 w-28 rounded-full bg-primary-100/80"></span>
            <span className="pointer-events-none absolute -bottom-10 -left-6 h-24 w-24 rounded-full bg-accent-100/80"></span>
            <div className="relative">
              <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-foreground-500">
                <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
                今日收拢进度
              </p>
              <div className="mt-5 flex items-end gap-8">
                <div>
                  <p className="font-heading text-4xl font-black text-foreground-950 md:text-5xl">
                    45<span className="text-primary-600">+</span>
                  </p>
                  <p className="mt-1 text-xs text-foreground-500">收藏大礼包条目</p>
                </div>
                <div className="h-14 w-px bg-background-300"></div>
                <div>
                  <p className="font-heading text-4xl font-black text-foreground-950 md:text-5xl">
                    6<span className="text-accent-600">类</span>
                  </p>
                  <p className="mt-1 text-xs text-foreground-500">主题分区索引</p>
                </div>
              </div>
              <div className="mt-6">
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>今日快讯已更新</span>
                  <span className="font-semibold text-primary-600">5 条</span>
                </div>
                <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                  <div className="h-full w-2/3 rounded-full bg-primary-500"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}